/**
 * Homepage FAQ question ids, each backed by `faq.<id>.q` / `faq.<id>.a`
 * messages in lang/fr.ts and lang/en.ts.
 *
 * Shared by the rendered accordion and the FAQPage JSON-LD, so the structured
 * data never drifts from what the page actually shows.
 */
export const FAQ_QUESTIONS = [
  "free",
  "devices",
  "onboarding",
  "import",
  "billing",
  "team",
  "data",
] as const;

export type FAQQuestionId = (typeof FAQ_QUESTIONS)[number];
